module.exports = __webpack_public_path__ + "static/media/un_global_goals.49bf500b.svg";